// extracted by mini-css-extract-plugin
export default {"BreadcrumbsBlock":"Breadcrumbs_BreadcrumbsBlock__YTW3Z","BreadcrumbsItem_text":"Breadcrumbs_BreadcrumbsItem_text__NR-4M"};